/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
/* eslint-disable indent */
import { useEffect, useCallback, useState, useMemo, Fragment } from "react";
import { Dropdown } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import toast from "react-hot-toast";
import { FaBuilding, FaEdit, FaTrash } from "react-icons/fa";
import { TiFlash } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Collapse } from "reactstrap";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from "recharts";
import { getAniosCierreDisponibles, getAniosFacturaDisponibles } from "../../constants/anios";
import { isAdmin as checkIsAdmin, AGENCIA_ADLAB_PERU } from "../../constants/permisos";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import {
  getCategorias,
  getSubcategorias,
  getContratos,
  getOportunidades,
  updateContrato,
  updateOportunidad,
  getUsers,
  getIntermediarios,
  getEdificiosOperativos,
  getClientes,
  getOportunidadesBTL,
  updateOportunidadBTL,
  tieneEdificiosAsignados,
} from "../../utils";
import { getRateForOpp, getImporteEnUSD } from "../../utils/calculateVentas";
import { cargarCobroPorVenta } from "../../utils/cobro/cargarCobroVentas";
import { getCotizacionesByCodigos } from "../../utils/cotizacionesGuardadas";
import { esVentaEnPeriodoBroker } from "../../utils/esVentaEnPeriodoBroker";
import { resolverNombreEjecutivo } from "../../utils/resolverNombreEjecutivo";
import { useEmpresaProductoFilter } from "../../utils/useEmpresaProductoFilter";
import { useExchangeRates } from "../../utils/useExchangeRates";
import { AgenciasDropdown, matchAgenciaFilter } from "../AgenciasDropdown";
import { CategoriaSubcategoriaFilter } from "../CategoriaSubcategoriaFilter";
import { FlashEditModal } from "../FlashEditModal";
import { ModalAsignarEdificios } from "../ModalAsignarEdificios";
import { ComparadorModal } from "./ComparadorModal";
import "./stylesVentasDetalle.scss";
import styles from "./VentasDetalle.module.scss";

export const VentasDetalle = ({ renderHeader } = {}) => {
  const [categorias, setCategorias] = useState([]);
  const [deletedOpportunity, setDeletedOpportunity] = useState(null);
  const [editingOpportunity, setEditingOpportunity] = useState(null);
  const [filtroAnoCierre, setFiltroAnoCierre] = useState([new Date().getFullYear().toString()]);
  const [filtroAnoFactura, setFiltroAnoFactura] = useState([new Date().getFullYear().toString()]);
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroSubcategoria, setFiltroSubcategoria] = useState("");
  const [subcategorias, setSubcategorias] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");
  const [filtroEstatus, setFiltroEstatus] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroMes, setFiltroMes] = useState([]);
  const [intermediaryMap, setIntermediaryMap] = useState({});
  const [intermediarios, setIntermediarios] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [oportunidades, setOportunidades] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [edificios, setEdificios] = useState([]);
  const [isBuildingsExpanded, setIsBuildingsExpanded] = useState(false);
  const [oportunidadesBTL, setOportunidadesBTL] = useState([]);
  const [contratos, setContratos] = useState([]);
  const [expandedContratos, setExpandedContratos] = useState(new Set());
  const [filtroMesCierre, setFiltroMesCierre] = useState([]);
  const [flashEditingOpportunity, setFlashEditingOpportunity] = useState(null);
  const [isFlashEditing, setIsFlashEditing] = useState(false);
  const [flashSaving, setFlashSaving] = useState(false);
  // Cuota cuyo modal de asignar edificios está abierto: { contratoId, idx } (null = cerrado).
  const [edificiosModalData, setEdificiosModalData] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [modoComparar, setModoComparar] = useState(false);
  const [seleccionComparar, setSeleccionComparar] = useState([]);
  const [comparadorOpen, setComparadorOpen] = useState(false);
  const [cotizacionesComparar, setCotizacionesComparar] = useState([]);

  const methods = useForm();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = methods;
  const { pais, id, rol, agencia } = useAuthContext();
  const isAdmin = checkIsAdmin(id);
  // Asignar edificios por mes es decisión comercial: solo gerencia/comercial o admin.
  const canAssignEdificios = isAdmin || rol === ROLES.GERENCIA || rol === ROLES.COMERCIAL;

  // Años de los filtros derivados de los datos cargados (no literales).
  // Cierre: mes_cierre de pautas + BTL, y mes_inicio/meses[] de contratos.
  // Factura: mes_factura (o `ano`) de pautas + BTL + contratos.
  const aniosCierreDisponibles = useMemo(
    () => getAniosCierreDisponibles([...oportunidades, ...oportunidadesBTL], contratos),
    [oportunidades, oportunidadesBTL, contratos]
  );
  const aniosFacturaDisponibles = useMemo(
    () => getAniosFacturaDisponibles([...oportunidades, ...oportunidadesBTL, ...contratos]),
    [oportunidades, oportunidadesBTL, contratos]
  );

  const puedeEditarOportunidad = (oportunidad) => {
    if (!oportunidad) return false;
    if (oportunidad.facturanumero) return false;
    if (oportunidad.estatus === "0%") return false;
    if (isAdmin) return true;
    if (rol !== ROLES.GERENCIA && rol !== ROLES.COMERCIAL && rol !== ROLES.BROKER) return false;
    // Defensa en profundidad: el broker solo edita ventas de SU cartera
    // (cliente.broker_id === su agencia). Refuerza el scoping de carga.
    if (rol === ROLES.BROKER) {
      const cliente = clientes.find((c) => String(c.id) === String(oportunidad.client_id));
      if (!cliente || cliente.broker_id !== parseInt(agencia, 10)) return false;
    }
    return true;
  };

  const { getDolarValue, dolarFallback, loaded: ratesLoaded } = useExchangeRates(pais);
  const fallbackRate = dolarFallback?.[pais] || 1;

  const [viewInUSD, setViewInUSD] = useState(false);

  const localString = useCallback(
    (paisArg) =>
      ({
        Chile: "es-CL",
        Perú: "es-PE",
        Uruguay: "es-UY",
        Region: "es-US",
      })[paisArg] || "es-UY",
    []
  );

  const moneda = useCallback(
    (paisArg) =>
      ({
        Chile: "$",
        Perú: "S/",
        Uruguay: "$",
      })[paisArg] || "$",
    []
  );

  const decimales = useCallback(
    (paisArg) =>
      ({
        Chile: 0,
        Perú: 2,
        Uruguay: 0,
      })[paisArg] || 0,
    []
  );

  // Conversión USD → moneda local con rate histórico por fecha de la opp.
  // Si moneda_dolar=false, retorna importe sin tocar.
  const getImporteLocal = useCallback(
    (op) => {
      // LISTA (7.22): VentasDetalle es ficha/detalle de la venta → muestra el importe de lista en ambas
      // monedas (la rama USD `getImporteEnUSD` ya es lista); no aplica el descuento de acuerdo OMNET.
      const importe = op.type === "btl" ? op.total_investment || 0 : parseFloat(op.importe) || 0;
      if (!op.moneda_dolar) return importe;
      const rate = getRateForOpp(op, getDolarValue, fallbackRate);
      return importe * rate;
    },
    [getDolarValue, fallbackRate]
  );

  // Formato unificado: símbolo + locale del país + decimales (USD siempre 2).
  const formatMoneda = useCallback(
    (valor, monedaDolar = false) => {
      if (valor === null || valor === undefined || isNaN(valor)) return "-";
      const simbolo = monedaDolar ? "US$" : moneda(pais);
      const locale = localString(pais);
      const dec = monedaDolar ? 2 : decimales(pais);
      const formatted = Number(valor).toLocaleString(locale, {
        minimumFractionDigits: dec,
        maximumFractionDigits: dec,
      });
      return `${simbolo} ${formatted}`;
    },
    [pais, moneda, localString, decimales]
  );

  const mesEnLetras = useCallback((mes) => {
    const mesesEnLetras = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];
    return mesesEnLetras[parseInt(mes) - 1] || "-";
  }, []);

  const isEditableByDate = (createdAt) => {
    const today = new Date("2025-04-19");
    const createdDate = new Date(createdAt);
    return !isNaN(createdDate) && createdDate >= today;
  };

  const navigate = useNavigate();

  const handleMesChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMes(selectedMonths);
  }, []);

  const handleMesCierreChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMesCierre(selectedMonths);
  }, []);

  const renderMesOptions = (filtro, onChangeHandler) =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`mes${filtro === filtroMes ? "factura" : "cierre"}${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtro.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={onChangeHandler}
        />
        <label className="form-check-label" htmlFor={`mes${filtro === filtroMes ? "factura" : "cierre"}${index}`}>
          {mes}
        </label>
      </div>
    ));

  // Filtro bidireccional empresa↔producto — lógica centralizada en useEmpresaProductoFilter.
  // En este componente el state de empresa se llama `filtroCliente` (alias) por compatibilidad
  // con las comparaciones de filtrado de tabla existentes (op.cliente / cliente.empresa).
  const clientesPais = useMemo(() => clientes.filter((cliente) => cliente.pais === pais), [clientes, pais]);
  const {
    filtroEmpresa: filtroCliente,
    filtroProducto,
    productosDeEmpresa,
    empresasDeProducto,
    empresaDisabled,
    productoDisabled,
    onChangeEmpresa,
    onChangeProducto,
  } = useEmpresaProductoFilter(clientesPais);

  const renderClientesOptions = () =>
    empresasDeProducto.map((empresa, index) => (
      <option key={index} value={empresa}>
        {empresa}
      </option>
    ));

  const renderProductosOptions = () =>
    productosDeEmpresa.map((producto, index) => (
      <option key={index} value={producto}>
        {producto}
      </option>
    ));

  const clienteCategoriaIdMap = useMemo(() => {
    const map = {};
    clientes.forEach((c) => {
      map[c.id] = { categoriaId: c.categoria, subcategoriaId: c.subcategoria_id };
    });
    return map;
  }, [clientes]);

  const clienteIntermediarioMap = useMemo(() => {
    const map = {};
    clientes.forEach((cliente) => {
      map[cliente.id] = cliente.agencia;
    });
    return map;
  }, [clientes]);

  const handleEstatusChange = (e) => {
    const value = e.target.value;
    setFiltroEstatus((prev) => (prev.includes(value) ? prev.filter((estatus) => estatus !== value) : [...prev, value]));
  };

  const renderEstatusOptions = () =>
    Object.entries({ "100%": 0, "90%": 1, "75%": 2, "50%": 3, "0%": 4 }).map(([estatus, _], index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`estatus${index}`}
          value={estatus}
          checked={filtroEstatus.includes(estatus)}
          onChange={handleEstatusChange}
        />
        <label className="form-check-label" htmlFor={`estatus${index}`}>
          {estatus}
        </label>
      </div>
    ));

  const handleEdit = (oportunidad) => {
    if (!puedeEditarOportunidad(oportunidad)) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    if (pais === "Perú" || pais === "Chile") {
      if (isEditableByDate(oportunidad.created_at)) {
        navigate(`/admin/online-cotizador/editar/${oportunidad.id}`, { state: { oportunidad } });
      } else {
        setEditingOpportunity(oportunidad);
        setIsEditing(true);
      }
    } else {
      console.warn("Edición no soportada para el país:", pais);
      toast.info("Edición no disponible para este país.");
    }
  };

  const onSubmitEdit = async (data) => {
    try {
      setLoading(true);
      const updatedOportunidad = {
        estatus: data.estatus,
        mes_cierre: data.mes_cierre,
        mes: data.mes,
        updated_at: new Date().toISOString(),
      };
      await updateOportunidad({ id: editingOpportunity.id, oportunidad: updatedOportunidad });
      toast.success("Oportunidad actualizada correctamente");
      setOportunidades((prev) =>
        prev.map((op) => (op.id === editingOpportunity.id ? { ...op, ...updatedOportunidad } : op))
      );
      setIsEditing(false);
      setEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setLoading(false);
    }
  };

  const months = [
    { value: "01", label: "ENE" },
    { value: "02", label: "FEB" },
    { value: "03", label: "MAR" },
    { value: "04", label: "ABR" },
    { value: "05", label: "MAY" },
    { value: "06", label: "JUN" },
    { value: "07", label: "JUL" },
    { value: "08", label: "AGO" },
    { value: "09", label: "SEP" },
    { value: "10", label: "OCT" },
    { value: "11", label: "NOV" },
    { value: "12", label: "DIC" },
  ];

  const handleDelete = async (id, type) => {
    try {
      setLoading(true);
      if (type === "btl") {
        await updateOportunidadBTL({ id, oportunidad: { eliminada: true } });
        setOportunidadesBTL((prev) => prev.map((op) => (op.full_id === id ? { ...op, eliminada: true } : op)));
      } else if (type === "contrato") {
        await updateContrato({ id, contrato: { eliminada: true } });
        setContratos((prev) => prev.map((op) => (op.id === id ? { ...op, eliminada: true } : op)));
      } else {
        await updateOportunidad({ id, oportunidad: { eliminada: true } });
        setOportunidades((prev) => prev.map((op) => (op.id === id ? { ...op, eliminada: true } : op)));
      }
      toast.success(
        type === "contrato" ? "El contrato se eliminó correctamente" : "La oportunidad se eliminó correctamente"
      );
      setShowConfirmationModal(false);
      setDeletedOpportunity(null);
    } catch (error) {
      console.error("Error deleting oportunidad:", error);
      toast.error("Hubo un error al eliminar, prueba de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmationModal = (oportunidad) => {
    setShowConfirmationModal(true);
    setDeletedOpportunity(oportunidad);
  };

  useEffect(() => {
    const fetchIntermediaries = async () => {
      try {
        const fetchedIntermediarios = await getIntermediarios({ pais });
        const map = fetchedIntermediarios.reduce((acc, inter) => {
          acc[inter.id] = inter.nombre;
          return acc;
        }, {});
        setIntermediaryMap(map);
        setIntermediarios(fetchedIntermediarios);
      } catch (error) {
        console.error("Error fetching intermediaries:", error);
      }
    };
    fetchIntermediaries();
  }, [pais]);

  useEffect(() => {
    if (editingOpportunity) {
      methods.reset({
        estatus: editingOpportunity.estatus || "",
        mes_cierre: editingOpportunity.mes_cierre || "01",
        mes: editingOpportunity.mes || "01",
      });
    }
  }, [editingOpportunity, methods]);

  const fetchData = useCallback(async () => {
    try {
      const normalizeMonthLocal = (month, ano, created_at, fallbackMonth = null) => {
        if (!month && !fallbackMonth) return null;
        const monthValue = month || fallbackMonth;
        const monthStr = monthValue.toString().trim();
        if (/^\d{2}-\d{4}$/.test(monthStr)) return monthStr;
        if (/^\d{4}-\d{2}-\d{2}$/.test(monthStr)) {
          return `${monthStr.slice(5, 7)}-${monthStr.slice(0, 4)}`;
        }
        const monthNum = parseInt(monthStr, 10);
        if (isNaN(monthNum) || monthNum < 1 || monthNum > 12) return null;
        const paddedMonth = monthNum.toString().padStart(2, "0");
        const year = ano ? ano.toString() : new Date(created_at).getFullYear().toString();
        return `${paddedMonth}-${year}`;
      };

      // 1. CARGAR CLIENTES PRIMERO (crucial)
      const fetchedClientes = await getClientes({ pais });
      const fetchedUsers = getUsers();
      const newOportunidadesRaw = getOportunidades({ pais });
      const newOportunidadesBTLRaw = getOportunidadesBTL({ pais: pais });
      const newContratosRaw = getContratos({ pais });
      const fetchedIntermediariosVentas = getIntermediarios({ pais });

      const ventasResults = await Promise.all([
        fetchedClientes,
        fetchedUsers,
        newOportunidadesRaw,
        newOportunidadesBTLRaw,
        newContratosRaw,
        fetchedIntermediariosVentas,
      ]);
      const usersData = ventasResults[1];
      // Intermediarios cargados acá (no del useEffect separado) para resolver el nombre del
      // broker en la columna EJECUTIVO sin race condition de carga.
      const intermediariosData = ventasResults[5] || [];
      // Rol BROKER sin scoping de LECTURA: ve todo el movimiento comercial de su país,
      // como comercial/gerencia. La edición sigue acotada a AdLab en `puedeEditarOportunidad`.
      const clientesData = ventasResults[0];
      const oportunidadesData = ventasResults[2];
      const btlData = ventasResults[3];
      const contratosData = ventasResults[4];

      setClientes(clientesData || []);
      setUsers(usersData || []);

      // 2. AHORA SÍ procesar oportunidades normales
      const mappedOportunidades = oportunidadesData.map((oportunidad) => {
        const ejecutivoName =
          resolverNombreEjecutivo(
            oportunidad.ejecutivo,
            usersData,
            intermediariosData,
            oportunidad.client_id,
            clientesData,
            oportunidad.created_at,
            oportunidad.estatus,
            oportunidad.fecha_cierre,
            oportunidad.excluir_broker
          ) ?? (typeof oportunidad.ejecutivo === "string" ? oportunidad.ejecutivo.split(" ")[0] : "Sin asignar");

        const normalizedMesCierre = normalizeMonthLocal(
          oportunidad.mes_cierre,
          oportunidad.ano || oportunidad.ano_cierre,
          oportunidad.created_at,
          oportunidad.mes_cierre_old || oportunidad.mes_old
        );

        const normalizedMesFactura = normalizeMonthLocal(
          oportunidad.mes_factura,
          oportunidad.ano || oportunidad.ano_cierre,
          oportunidad.created_at,
          oportunidad.mes_old || oportunidad.mes_cierre_old
        );

        const anoOportunidad =
          normalizedMesCierre?.split("-")?.[1] ||
          normalizedMesFactura?.split("-")?.[1] ||
          new Date(oportunidad.created_at).getFullYear().toString();

        return {
          ...oportunidad,
          ejecutivoId: oportunidad.ejecutivo,
          ejecutivo: ejecutivoName,
          mes_cierre: normalizedMesCierre,
          mes_factura: normalizedMesFactura,
          estatus: oportunidad.estatus || (oportunidad.status ? `${oportunidad.status}%` : "0%"),
          ano: anoOportunidad,
        };
      });
      // Recaudada por la VERDAD de cobro real (getCobroReal overlay), NO el facturafechacobro crudo
      // de la venta. Solo display (la "Fecha de Cobro" del detalle). Overlay SOLO sobre sales —
      // contratos/BTL se dejan como están (su fecha vive por mes/sub-fila, fuera de alcance acá).
      const cobroPorVenta = await cargarCobroPorVenta(pais).catch(() => new Map());
      mappedOportunidades.forEach((op) => {
        if (op.type === "contrato" || op.type === "btl" || op.isBTL) return;
        const cobro = cobroPorVenta.get(`sales:${op.id}:`);
        op.facturafechacobro = cobro?.cobrada ? cobro.fecha || op.facturafecha : null;
      });
      setOportunidades(mappedOportunidades);

      // 3. AHORA SÍ procesar BTL (con clientes ya cargados)
      const mappedBTL = btlData
        .filter((btl) => !btl.eliminada && btl.pais === pais)
        .map((btl) => {
          const clienteEmpresa =
            clientesData.find((c) => String(c.id) === String(btl.client_id))?.empresa || "Cliente no encontrado";
          const ejecutivoName =
            resolverNombreEjecutivo(
              btl.executive_responsible || btl.created_by,
              usersData,
              intermediariosData,
              btl.client_id,
              clientesData,
              btl.created_at,
              btl.status ? `${btl.status}%` : "75%",
              btl.fecha_cierre,
              btl.excluir_broker
            ) ?? "Sin asignar";
          return {
            ...btl,
            id: btl.numeric_id.toString(),
            full_id: btl.id,
            type: "btl",
            cliente: clienteEmpresa,
            ejecutivo: ejecutivoName,
            ejecutivoId: btl.executive_responsible || btl.created_by,
            mes_cierre: btl.mes_cierre || null,
            mes_factura: btl.mes_factura || null,
            estatus: btl.status ? `${btl.status}%` : "75%",
            ano: btl.mes_cierre?.split("-")[1] || "2025",
            facturanumero: btl.facturanumero,
            facturafecha: btl.facturafecha,
          };
        });

      setOportunidadesBTL(mappedBTL);

      // 4. Procesar contratos multi-mes
      const mappedContratos = (contratosData || [])
        .filter((c) => !c.eliminada && c.pais === pais)
        .map((c) => {
          const clienteEmpresa =
            clientesData.find((cl) => String(cl.id) === String(c.client_id))?.empresa || c.cliente || "Sin cliente";
          const ejecutivoName =
            resolverNombreEjecutivo(
              c.ejecutivo,
              usersData,
              intermediariosData,
              c.client_id,
              clientesData,
              c.created_at,
              c.estatus,
              c.fecha_cierre,
              c.excluir_broker
            ) ?? "Sin asignar";
          // Si alguna cuota del contrato ya tiene factura emitida, el contrato
          // queda congelado (mismo criterio que sales.facturanumero).
          const tieneCuotaFacturada = (c.meses || []).some((m) => m?.facturanumero);
          return {
            ...c,
            type: "contrato",
            cliente: clienteEmpresa,
            ejecutivo: ejecutivoName,
            ejecutivoId: c.ejecutivo,
            importe: c.importe_total,
            mes_factura: c.mes_inicio,
            estatus: c.estatus || "50%",
            ano: c.ano?.toString() || c.mes_inicio?.split("-")[1] || "2026",
            facturanumero: tieneCuotaFacturada ? "CONTRATO_FACTURADO" : null,
          };
        });
      setContratos(mappedContratos);

      // resto de cargas (categorías, edificios, etc.)
      const newCategorias = await getCategorias();
      setCategorias(newCategorias);
      const newSubcategorias = await getSubcategorias();
      setSubcategorias(newSubcategorias || []);
      const fetchedEdificios = await getEdificiosOperativos({ pais });
      setEdificios(fetchedEdificios || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Error al cargar datos");
    }
  }, [pais]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Flash form state ahora se maneja dentro de FlashEditModal

  const handleAnoCierreChange = (e) => {
    const value = e.target.value;
    setFiltroAnoCierre((prev) => (prev.includes(value) ? prev.filter((ano) => ano !== value) : [...prev, value]));
  };

  const handleAnoFacturaChange = (e) => {
    const value = e.target.value;
    setFiltroAnoFactura((prev) => (prev.includes(value) ? prev.filter((ano) => ano !== value) : [...prev, value]));
  };

  const handleFlashEdit = (oportunidad) => {
    if (!puedeEditarOportunidad(oportunidad)) {
      toast.error("No tienes permiso para editar esta oportunidad.");
      return;
    }
    if (oportunidad.type === "btl") {
      toast.info("La edición de oportunidades BTL está en desarrollo.");
      return;
    }
    // Contratos: solo editar status y cierre (no factura, ya que es un rango)
    const cliente = clientes.find((c) => c.id === oportunidad.client_id);
    setFlashEditingOpportunity({ ...oportunidad, clienteNombre: cliente?.nombre || cliente?.empresa || "" });
    setIsFlashEditing(true);
  };

  const onSubmitFlashEdit = async (updatedFields) => {
    try {
      setFlashSaving(true);
      if (flashEditingOpportunity.type === "contrato") {
        await updateContrato({ id: flashEditingOpportunity.id, contrato: updatedFields });
        toast.success("Contrato actualizado correctamente");
        setContratos((prev) =>
          prev.map((op) => (op.id === flashEditingOpportunity.id ? { ...op, ...updatedFields } : op))
        );
      } else {
        await updateOportunidad({ id: flashEditingOpportunity.id, oportunidad: updatedFields });
        toast.success("Oportunidad actualizada correctamente");
        setOportunidades((prev) =>
          prev.map((op) => (op.id === flashEditingOpportunity.id ? { ...op, ...updatedFields } : op))
        );
      }
      setIsFlashEditing(false);
      setFlashEditingOpportunity(null);
    } catch (error) {
      console.error("Error updating oportunidad:", error);
      toast.error("Error al actualizar la oportunidad");
    } finally {
      setFlashSaving(false);
    }
  };

  // Persiste la asignación de edificios de una cuota: clona meses, patchea meses[idx] con el
  // payload de ModalAsignarEdificios y escribe con updateContrato directo (mismo shape que
  // escribía handleSaveEdificiosCuota en el flash). Refresca el state local sin recargar.
  const handleSaveEdificiosCuota = async (
    idsString,
    edificiosTotales,
    pantallasTotales,
    personasAsignadas,
    perTypeData
  ) => {
    if (!edificiosModalData) return;
    const { contratoId, idx } = edificiosModalData;
    try {
      const contrato = contratos.find((c) => c.id === contratoId);
      if (!contrato) throw new Error("Contrato no encontrado");
      const meses = [...(contrato.meses || [])];
      meses[idx] = {
        ...meses[idx],
        edificios_ids: idsString || null,
        edificios_totales: edificiosTotales,
        pantallas_totales: pantallasTotales,
        personas_asignadas: personasAsignadas,
        pantallas_ascensores: perTypeData?.pantallas_ascensores || "",
        pantallas_espera: perTypeData?.pantallas_espera || "",
        pantallas_circulacion: perTypeData?.pantallas_circulacion || "",
        pantallas_cowork: perTypeData?.pantallas_cowork || "",
      };
      await updateContrato({ id: contratoId, contrato: { meses } });
      setContratos((prev) => prev.map((c) => (c.id === contratoId ? { ...c, meses } : c)));
      toast.success("Edificios asignados correctamente");
      setEdificiosModalData(null);
    } catch (error) {
      console.error("Error asignando edificios:", error);
      toast.error("Error al asignar edificios");
    }
  };

  // Props derivadas del modal de edificios abierto (cuota + contrato en contexto).
  const edificiosCuotaCtx = (() => {
    if (!edificiosModalData) return null;
    const contrato = contratos.find((c) => c.id === edificiosModalData.contratoId);
    const cuota = contrato?.meses?.[edificiosModalData.idx];
    if (!cuota) return null;
    const [mm, yyyy] = (cuota.mes || "").split("-");
    return {
      personasComprometidas: contrato.personas_comprometidas || 0,
      edificiosIds: cuota.edificios_ids || null,
      mesLabel: `${mesEnLetras(mm)}/${yyyy || ""}`,
    };
  })();

  const getRadius = (key, data) => {
    const keys = Object.keys(data).filter((k) => data[k] > 0);
    const firstKey = keys[0];
    const lastKey = keys.at(-1);
    if (firstKey === key && lastKey === key) return [10, 10, 10, 10];
    if (firstKey === key) return [10, 0, 0, 10];
    if (lastKey === key) return [0, 10, 10, 0];
    return [0, 0, 0, 0];
  };

  const customStatusOrder = { "100%": 0, "90%": 1, "75%": 2, "50%": 3, "0%": 4 };

  // Atribución AdLab de UNA fila (Perú). Fuente única para ADLAB y su complemento Visiona.
  //  - porEjecutivoBroker: la venta la creó un usuario rol broker de esa agencia (PRESERVADO).
  //  - predicadoCuentaPeríodo: BTL por CUENTA (sin período — sales_btl no tiene fecha_cierre/
  //    excluir_broker); sales/contrato período-aware vía esVentaEnPeriodoBroker (respeta
  //    excluir_broker, fecha_cierre y 100% cerrada pre-junio).
  const esFilaAdLab = (oportunidad, interId, cliente) => {
    const u = users.find((uu) => String(uu.id) === String(oportunidad.ejecutivoId));
    const porEjecutivoBroker = !!u && u.rol === ROLES.BROKER && String(u.agencia) === String(interId);
    const predicadoCuentaPeriodo =
      oportunidad.type === "btl"
        ? String(cliente?.broker_id) === String(interId)
        : esVentaEnPeriodoBroker(oportunidad, cliente);
    return porEjecutivoBroker || predicadoCuentaPeriodo;
  };

  const oportunidadesFiltradas = [...oportunidades, ...oportunidadesBTL, ...contratos].filter((oportunidad) => {
    const cliente = clientes.find((c) => c.id === oportunidad.client_id && c.pais === pais);
    const clienteMatch = !filtroCliente || (cliente && cliente.empresa === filtroCliente);
    const productoMatch = !filtroProducto || (cliente && cliente.producto === filtroProducto);

    // Extraer mes y año de cierre de la oportunidad
    const mesCierreOportunidad = oportunidad.mes_cierre ? oportunidad.mes_cierre.split("-")[0] : null;
    const anoCierreOportunidad = oportunidad.mes_cierre ? oportunidad.mes_cierre.split("-")[1] : null;

    // Filtro combinado de cierre: mes Y año deben coincidir cuando ambos están seleccionados
    const cierreMatch = (() => {
      const hayFiltroMes = filtroMesCierre.length > 0;
      const hayFiltroAno = filtroAnoCierre.length > 0;
      if (!hayFiltroMes && !hayFiltroAno) return true;
      if (!mesCierreOportunidad || !anoCierreOportunidad) return false;
      const mesCoincide = !hayFiltroMes || filtroMesCierre.includes(mesCierreOportunidad);
      const anoCoincide = !hayFiltroAno || filtroAnoCierre.includes(anoCierreOportunidad);
      return mesCoincide && anoCoincide;
    })();

    // Extraer mes y año de factura de la oportunidad
    const mesFacturaOportunidad = oportunidad.facturafecha
      ? String(new Date(oportunidad.facturafecha).getMonth() + 1).padStart(2, "0")
      : oportunidad.mes_factura
        ? oportunidad.mes_factura.split("-")[0]
        : null;
    const anoFacturaOportunidad = oportunidad.facturafecha
      ? new Date(oportunidad.facturafecha).getFullYear().toString()
      : oportunidad.mes_factura
        ? oportunidad.mes_factura.split("-")[1]
        : null;

    // Filtro combinado de factura: mes Y año deben coincidir cuando ambos están seleccionados
    const facturaMatch = (() => {
      const hayFiltroMes = filtroMes.length > 0;
      const hayFiltroAno = filtroAnoFactura.length > 0;
      if (!hayFiltroMes && !hayFiltroAno) return true;
      if (!mesFacturaOportunidad || !anoFacturaOportunidad) return false;
      const mesCoincide = !hayFiltroMes || filtroMes.includes(mesFacturaOportunidad);
      const anoCoincide = !hayFiltroAno || filtroAnoFactura.includes(anoFacturaOportunidad);
      return mesCoincide && anoCoincide;
    })();

    const estatusMatch = filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus);
    const categoriaMatch =
      !filtroCategoria || String(clienteCategoriaIdMap[oportunidad.client_id]?.categoriaId) === String(filtroCategoria);
    const subcategoriaMatch =
      !filtroSubcategoria ||
      String(clienteCategoriaIdMap[oportunidad.client_id]?.subcategoriaId) === String(filtroSubcategoria);
    let ejecutivoMatch;
    if (!filtroEjecutivo) {
      ejecutivoMatch = true;
    } else if (filtroEjecutivo.startsWith("broker:")) {
      // ADLAB unificado (período-aware): ejecutivo broker de esa agencia, O fila atribuida a
      // AdLab por cuenta/período (esVentaEnPeriodoBroker en sales/contrato; cuenta en BTL).
      // `cliente` ya resuelto arriba (757). Reemplaza el enPeriodoBroker inline laxo.
      ejecutivoMatch = esFilaAdLab(oportunidad, filtroEjecutivo.slice("broker:".length), cliente);
    } else if (filtroEjecutivo === "grupo:visiona") {
      // Visiona = complemento EXACTO de AdLab sobre la MISMA fila (misma fuente esFilaAdLab).
      ejecutivoMatch = !esFilaAdLab(oportunidad, AGENCIA_ADLAB_PERU, cliente);
    } else {
      ejecutivoMatch = String(oportunidad.ejecutivoId) === String(filtroEjecutivo);
    }
    const intermediaryId = clienteIntermediarioMap[oportunidad.client_id] || null;
    const intermediarioMatch = matchAgenciaFilter(filtroIntermediario, intermediaryId, pais);
    return (
      clienteMatch &&
      productoMatch &&
      cierreMatch &&
      facturaMatch &&
      estatusMatch &&
      intermediarioMatch &&
      categoriaMatch &&
      subcategoriaMatch &&
      ejecutivoMatch &&
      !oportunidad.eliminada
    );
  });

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const toggleContrato = (id) => {
    setExpandedContratos((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const parseMesAno = (mesAnoStr) => {
    if (!mesAnoStr || typeof mesAnoStr !== "string") return 0;
    const parts = mesAnoStr.split("-");
    if (parts.length !== 2) return 0;
    const mes = parseInt(parts[0], 10);
    const ano = parseInt(parts[1], 10);
    return ano * 12 + mes;
  };

  const sortedOportunidades = [...oportunidadesFiltradas].sort((a, b) => {
    // Si hay un sortConfig activo, usarlo
    if (sortConfig.key) {
      const direction = sortConfig.direction === "asc" ? 1 : -1;

      switch (sortConfig.key) {
        case "id":
          return direction * (parseInt(a.id) - parseInt(b.id));
        case "cliente":
          return direction * (a.cliente || "").localeCompare(b.cliente || "");
        case "campana":
          return direction * (a.campana || "").localeCompare(b.campana || "");
        case "cierre": {
          const cierreA = parseMesAno(a.mes_cierre);
          const cierreB = parseMesAno(b.mes_cierre);
          return direction * (cierreA - cierreB);
        }
        case "factura": {
          const facturaA = a.facturafecha
            ? new Date(a.facturafecha).getTime()
            : parseMesAno(a.mes_factura) * 2629800000;
          const facturaB = b.facturafecha
            ? new Date(b.facturafecha).getTime()
            : parseMesAno(b.mes_factura) * 2629800000;
          return direction * (facturaA - facturaB);
        }
        case "ticket": {
          // Sort consistente: convertir todo a USD via rate histórico
          const importeA = getImporteEnUSD(a, getDolarValue, fallbackRate);
          const importeB = getImporteEnUSD(b, getDolarValue, fallbackRate);
          return direction * (importeA - importeB);
        }
        case "status": {
          const statusA = customStatusOrder[a.estatus || "0%"];
          const statusB = customStatusOrder[b.estatus || "0%"];
          return direction * (statusA - statusB);
        }
        case "ejecutivo":
          return direction * (a.ejecutivo || "").localeCompare(b.ejecutivo || "");
        default:
          break;
      }
    }

    // Ordenamiento por defecto:
    //   1. 100% al tope, ordenados por mes_factura ASC (YTD)
    //   2. 90% → 75% → 50% en el medio, por importe DESC dentro de cada status
    //   3. 0% al fondo, ordenados por mes_cierre ASC
    const statusA = customStatusOrder[a.estatus || "0%"];
    const statusB = customStatusOrder[b.estatus || "0%"];
    if (statusA !== statusB) {
      return statusA - statusB;
    }
    const importeA = getImporteEnUSD(a, getDolarValue, fallbackRate);
    const importeB = getImporteEnUSD(b, getDolarValue, fallbackRate);
    const estatus = a.estatus || "0%";
    if (estatus === "100%") {
      const facturaA = parseMesAno(a.mes_factura);
      const facturaB = parseMesAno(b.mes_factura);
      if (facturaA !== facturaB) return facturaA - facturaB;
      return importeB - importeA;
    }
    if (estatus === "0%") {
      const cierreA = parseMesAno(a.mes_cierre);
      const cierreB = parseMesAno(b.mes_cierre);
      if (cierreA !== cierreB) return cierreA - cierreB;
      return importeB - importeA;
    }
    return importeB - importeA;
  });

  const renderEjecutivosOptions = () => {
    const countryMapping = { Uruguay: "URU", Perú: "PER", Chile: "CHI" };
    const countryCode = countryMapping[pais] || "";
    const ejecutivosUnicos = users
      .filter((user) => {
        const userPais = user.pais || "";
        const userRol = user.rol ? user.rol.toLowerCase().trim() : "";
        const validRoles = ["comercial", "gerencia"].map((r) => r.toLowerCase());
        return (userPais === countryCode || !countryCode) && validRoles.includes(userRol) && user.habilitado === true;
      })
      .sort((a, b) => `${a.nombre} ${a.apellido}`.localeCompare(`${b.nombre} ${b.apellido}`));

    // Brokers: se agrupan bajo su intermediario (ej. "AdLab") como una sola opción
    // adicional. value = "broker:<intermediarioId>" para que el predicado matchee a
    // todos los brokers de esa agencia (1623/1624 → AdLab).
    const brokerInterIds = [
      ...new Set(
        users
          .filter((u) => {
            const userPais = u.pais || "";
            return (userPais === countryCode || !countryCode) && u.rol === ROLES.BROKER && u.agencia;
          })
          .map((u) => String(u.agencia))
      ),
    ];

    return [
      ...ejecutivosUnicos.map((user) => (
        <option key={`u-${user.id}`} value={user.id}>
          {`${user.nombre} ${user.apellido}`}
        </option>
      )),
      ...brokerInterIds.map((interId) => (
        <option key={`b-${interId}`} value={`broker:${interId}`}>
          {intermediaryMap[interId] || `Broker ${interId}`}
        </option>
      )),
      // Visiona = complemento exacto de AdLab. Solo Perú (hay ≥1 agencia broker); en Chile no se emite.
      ...(brokerInterIds.length > 0
        ? [
            <option key="grupo-visiona" value="grupo:visiona">
              Visiona
            </option>,
          ]
        : []),
    ];
  };

  const handleShowDetails = (oportunidad) => {
    setSelectedOpportunity(oportunidad);
    setShowDetailsModal(true);
  };

  const toggleBuildingsList = () => {
    setIsBuildingsExpanded(!isBuildingsExpanded);
  };

  // --- Modo Comparar ---
  const clientesConMultiples = useMemo(() => {
    const conteo = {};
    sortedOportunidades.forEach((op) => {
      if (!op.client_id) return;
      const estatus = op.estatus;
      if (estatus === "50%" || estatus === "75%" || estatus === "90%") {
        conteo[op.client_id] = (conteo[op.client_id] || 0) + 1;
      }
    });
    const ids = new Set();
    Object.entries(conteo).forEach(([clientId, count]) => {
      if (count >= 2) ids.add(Number(clientId));
    });
    return ids;
  }, [sortedOportunidades]);

  const oportunidadesComparar = useMemo(() => {
    if (!modoComparar) return sortedOportunidades;
    const ESTATUS_COMPARABLES = new Set(["50%", "75%", "90%"]);
    const filtered = sortedOportunidades.filter(
      (op) => op.client_id && clientesConMultiples.has(Number(op.client_id)) && ESTATUS_COMPARABLES.has(op.estatus)
    );
    return [...filtered].sort((a, b) => {
      const clientCmp = String(a.cliente || "").localeCompare(String(b.cliente || ""));
      if (clientCmp !== 0) return clientCmp;
      return (Number(b.importe) || 0) - (Number(a.importe) || 0);
    });
  }, [modoComparar, sortedOportunidades, clientesConMultiples]);

  const handleToggleComparar = () => {
    setModoComparar((prev) => !prev);
    setSeleccionComparar([]);
  };

  const handleSelectComparar = (oportunidad) => {
    setSeleccionComparar((prev) => {
      const yaSeleccionada = prev.find(
        (s) => s.id === oportunidad.id && (s.type || "regular") === (oportunidad.type || "regular")
      );
      if (yaSeleccionada) {
        return prev.filter(
          (s) => !(s.id === oportunidad.id && (s.type || "regular") === (oportunidad.type || "regular"))
        );
      }
      if (prev.length > 0 && Number(prev[0].client_id) !== Number(oportunidad.client_id)) {
        return [oportunidad];
      }
      if (prev.length >= 4) return prev;
      return [...prev, oportunidad];
    });
  };

  const isSelectedComparar = (oportunidad) =>
    seleccionComparar.some((s) => s.id === oportunidad.id && (s.type || "regular") === (oportunidad.type || "regular"));

  const selectedClientId = seleccionComparar.length > 0 ? Number(seleccionComparar[0].client_id) : null;

  const salesData = useMemo(() => {
    // Usamos exactamente las oportunidades que ya están filtradas y ordenadas para la tabla
    const oportunidadesVisibles = sortedOportunidades;

    // Conversión por op según viewInUSD: rate histórico de calculateVentas.js
    const getValor = (op) => (viewInUSD ? getImporteEnUSD(op, getDolarValue, fallbackRate) : getImporteLocal(op));

    // Helper: para mismo client_id con múltiples oportunidades, tomar solo la de menor valor
    const getMinByClient = (ops) => {
      const byClient = {};
      ops.forEach((op) => {
        const clientId = op.client_id || op.cliente;
        const importe = getValor(op);
        if (!byClient[clientId] || importe < byClient[clientId]) {
          byClient[clientId] = importe;
        }
      });
      return Object.values(byClient).reduce((sum, val) => sum + val, 0);
    };

    // Filtrar por estatus
    const ops100 = oportunidadesVisibles.filter((op) => op.estatus === "100%");
    const ops90 = oportunidadesVisibles.filter((op) => op.estatus === "90%");
    const ops75 = oportunidadesVisibles.filter((op) => op.estatus === "75%");
    const ops50 = oportunidadesVisibles.filter((op) => op.estatus === "50%");
    const ops0 = oportunidadesVisibles.filter((op) => op.estatus === "0%");

    // 100% suma todo (ya cerrado), 90%/75% aplica deduplicación por cliente
    const suma100 = ops100.reduce((acc, op) => acc + getValor(op), 0);
    const suma90 = getMinByClient(ops90);
    const suma75 = getMinByClient(ops75);
    const suma50 = ops50.reduce((acc, op) => acc + getValor(op), 0);
    const suma0 = ops0.reduce((acc, op) => acc + getValor(op), 0);

    const total = suma100 + suma90 + suma75 + suma50 + suma0;

    return {
      sumaImportes100: Math.round(suma100),
      sumaImportes90: Math.round(suma90),
      sumaImportes75: Math.round(suma75),
      sumaImportes50: Math.round(suma50),
      sumaImportes0: Math.round(suma0),
      chartData: [
        {
          name: "Total",
          "100%": total ? (suma100 / total) * 100 : 0,
          "90%": total ? (suma90 / total) * 100 : 0,
          "75%": total ? (suma75 / total) * 100 : 0,
          "50%": total ? (suma50 / total) * 100 : 0,
          "0%": total ? (suma0 / total) * 100 : 0,
          empty: total === 0 ? 100 : 0,
        },
      ],
    };
  }, [sortedOportunidades, viewInUSD, getDolarValue, fallbackRate, getImporteLocal]);

  const filtersContent = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        gap: "16px",
      }}
    >
      <div className={styles.filtersContainer} style={{ flex: 1 }}>
        {/* Fila 1: Empresa, Producto, Categoría, Agencia, Ejecutivo */}
        <div className={styles.filterRow}>
          <div>
            <select
              className={`form-control ${filtroCliente ? styles.activeFilter : ""}`}
              value={filtroCliente}
              onChange={(e) => onChangeEmpresa(e.target.value)}
              disabled={empresaDisabled}
              style={empresaDisabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
            >
              <option value="">{empresaDisabled ? empresasDeProducto[0] : "Empresa"}</option>
              {renderClientesOptions()}
            </select>
          </div>
          <div>
            <select
              className={`form-control ${filtroProducto ? styles.activeFilter : ""}`}
              value={filtroProducto}
              onChange={(e) => onChangeProducto(e.target.value)}
              disabled={productoDisabled}
              style={productoDisabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
            >
              <option value="">{productoDisabled ? productosDeEmpresa[0] : "Producto"}</option>
              {renderProductosOptions()}
            </select>
          </div>
          <CategoriaSubcategoriaFilter
            categorias={categorias}
            subcategorias={subcategorias}
            filtroCategoria={filtroCategoria}
            filtroSubcategoria={filtroSubcategoria}
            onCategoriaChange={setFiltroCategoria}
            onSubcategoriaChange={setFiltroSubcategoria}
            className="form-control"
            activeClass={styles.activeFilter}
          />
          <div>
            <AgenciasDropdown
              value={filtroIntermediario}
              onChange={(e) => setFiltroIntermediario(e.target.value)}
              intermediarios={intermediarios}
              placeholder="Agencia"
              className={`form-control ${filtroIntermediario ? styles.activeFilter : ""}`}
            />
          </div>
          <div>
            <select
              className={`form-control ${filtroEjecutivo ? styles.activeFilter : ""}`}
              value={filtroEjecutivo}
              onChange={(e) => setFiltroEjecutivo(e.target.value)}
            >
              <option value="">Ejecutivo</option>
              {renderEjecutivosOptions()}
            </select>
          </div>
        </div>
        {/* Fila 2: Mes Cierre, Año Cierre, Mes Factura, Año Factura, Status */}
        <div className={styles.filterRow}>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-mes-cierre"
                className={`form-control text-start ${filtroMesCierre.length > 0 ? styles.activeFilter : ""}`}
              >
                {filtroMesCierre.length === 0
                  ? "Mes cierre"
                  : filtroMesCierre.length >= 4
                    ? "Varios"
                    : filtroMesCierre.map((mes) => mesEnLetras(mes)).join(", ")}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderMesOptions(filtroMesCierre, handleMesCierreChange)}</Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-ano-cierre"
                className={`form-control text-start ${filtroAnoCierre.length > 0 ? styles.activeFilter : ""}`}
              >
                Año cierre
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {aniosCierreDisponibles.map((ano, index) => (
                  <div key={index} className="form-check left-aligned-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`anoCierre${index}`}
                      value={ano}
                      checked={filtroAnoCierre.includes(ano)}
                      onChange={handleAnoCierreChange}
                    />
                    <label className="form-check-label" htmlFor={`anoCierre${index}`}>
                      {ano}
                    </label>
                  </div>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-mes-factura"
                className={`form-control text-start ${filtroMes.length > 0 ? styles.activeFilter : ""}`}
              >
                {filtroMes.length === 0
                  ? "Mes factura"
                  : filtroMes.length >= 4
                    ? "Varios"
                    : filtroMes.map((mes) => mesEnLetras(mes)).join(", ")}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderMesOptions(filtroMes, handleMesChange)}</Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-ano-factura"
                className={`form-control text-start ${filtroAnoFactura.length > 0 ? styles.activeFilter : ""}`}
              >
                Año factura
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {aniosFacturaDisponibles.map((ano, index) => (
                  <div key={index} className="form-check left-aligned-checkbox">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`anoFactura${index}`}
                      value={ano}
                      checked={filtroAnoFactura.includes(ano)}
                      onChange={handleAnoFacturaChange}
                    />
                    <label className="form-check-label" htmlFor={`anoFactura${index}`}>
                      {ano}
                    </label>
                  </div>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle
                variant="white border"
                id="dropdown-status"
                className={`form-control text-start ${filtroEstatus.length > 0 ? styles.activeFilter : ""}`}
              >
                {filtroEstatus.length === 0
                  ? "Status"
                  : filtroEstatus.length >= 4
                    ? "Varios"
                    : filtroEstatus.join(", ")}
              </Dropdown.Toggle>
              <Dropdown.Menu>{renderEstatusOptions()}</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          gap: "8px",
          marginRight: "16px",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            whiteSpace: "nowrap",
            cursor: "pointer",
            fontSize: "0.85rem",
            color: "#000",
          }}
        >
          Ver en dólares
          <input
            type="checkbox"
            checked={viewInUSD}
            onChange={(e) => setViewInUSD(e.target.checked)}
            disabled={!ratesLoaded}
          />
        </label>
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            whiteSpace: "nowrap",
            cursor: "pointer",
            fontSize: "0.85rem",
            color: "#000",
          }}
        >
          Comparar
          <input type="checkbox" checked={modoComparar} onChange={handleToggleComparar} />
        </label>
      </div>
    </div>
  );

  return (
    <div className="container-ventas-detalle">
      {renderHeader ? renderHeader(filtersContent) : filtersContent}
      <div className="row justify-content-center mb-2">
        <div className="col-md-12">
          <div className="d-flex justify-content-between">
            {/* 100% */}
            <div
              className="text-center p-2 bg-success border border-dark m-3 text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>100%</strong>
              </div>
              <div>{salesData.sumaImportes100 > 0 ? formatMoneda(salesData.sumaImportes100, viewInUSD) : "-"}</div>
            </div>

            {/* 90% */}
            <div
              className="text-center p-2 bg-danger border border-dark m-3 text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>90%</strong>
              </div>
              <div>{salesData.sumaImportes90 > 0 ? formatMoneda(salesData.sumaImportes90, viewInUSD) : "-"}</div>
            </div>

            {/* 75% */}
            <div
              className="text-center border border-dark p-2 bg-primary m-3 text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>75%</strong>
              </div>
              <div>{salesData.sumaImportes75 > 0 ? formatMoneda(salesData.sumaImportes75, viewInUSD) : "-"}</div>
            </div>

            {/* 50% */}
            <div
              className="text-center p-2 bg-warning m-3 border border-dark text-dark"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>50%</strong>
              </div>
              <div>{salesData.sumaImportes50 > 0 ? formatMoneda(salesData.sumaImportes50, viewInUSD) : "-"}</div>
            </div>

            {/* 0% */}
            <div
              className="text-center p-2 bg-black m-3 border border-dark text-white"
              style={{ borderRadius: "4px", width: "225px" }}
            >
              <div>
                <strong>0%</strong>
              </div>
              <div>{salesData.sumaImportes0 > 0 ? formatMoneda(salesData.sumaImportes0, viewInUSD) : "-"}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <ResponsiveContainer width="100%" height={80} className="p-0 m-0">
            <BarChart layout="vertical" data={salesData.chartData} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
              <XAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
              <YAxis type="category" dataKey="name" hide />

              {/* Acá está el fix: todo chartData → salesData.chartData */}
              {salesData.chartData[0].empty > 0 ? (
                <Bar dataKey="empty" fill="#555555" isAnimationActive={false} radius={[10, 10, 10, 10]}>
                  <LabelList dataKey="empty" position="center" formatter={() => "SIN DATOS"} fill="#FFF" />
                </Bar>
              ) : (
                <>
                  {salesData.chartData[0]["100%"] > 0 && (
                    <Bar dataKey="100%" stackId="a" fill="#198754" radius={getRadius("100%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="100%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["90%"] > 0 && (
                    <Bar dataKey="90%" stackId="a" fill="#dc3545" radius={getRadius("90%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="90%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["75%"] > 0 && (
                    <Bar dataKey="75%" stackId="a" fill="#0d6efd" radius={getRadius("75%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="75%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["50%"] > 0 && (
                    <Bar dataKey="50%" stackId="a" fill="#ffc107" radius={getRadius("50%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="50%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#000"
                      />
                    </Bar>
                  )}
                  {salesData.chartData[0]["0%"] > 0 && (
                    <Bar dataKey="0%" stackId="a" fill="#000000" radius={getRadius("0%", salesData.chartData[0])}>
                      <LabelList
                        dataKey="0%"
                        position="center"
                        formatter={(value) => `${Math.round(value)}%`}
                        fill="#fff"
                      />
                    </Bar>
                  )}
                </>
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-12">
          <table className="table table-bordered table-striped table-hover table-sm">
            <thead className="text-center align-middle">
              <tr>
                {modoComparar && <th style={{ width: "3%" }} />}
                <th style={{ width: modoComparar ? "3%" : "4%", cursor: "pointer" }} onClick={() => handleSort("id")}>
                  ID{" "}
                  {sortConfig.key === "id" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "16%", cursor: "pointer" }} onClick={() => handleSort("cliente")}>
                  CLIENTE{" "}
                  {sortConfig.key === "cliente" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "11%", cursor: "pointer" }} onClick={() => handleSort("campana")}>
                  CAMPAÑA{" "}
                  {sortConfig.key === "campana" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "6%", cursor: "pointer" }} onClick={() => handleSort("cierre")}>
                  CIERRE{" "}
                  {sortConfig.key === "cierre" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "10%", cursor: "pointer" }} onClick={() => handleSort("factura")}>
                  FACTURA{" "}
                  {sortConfig.key === "factura" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "8%", cursor: "pointer" }} onClick={() => handleSort("ticket")}>
                  TICKET{" "}
                  {sortConfig.key === "ticket" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "6%", cursor: "pointer" }} onClick={() => handleSort("status")}>
                  STATUS{" "}
                  {sortConfig.key === "status" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th style={{ width: "6%", cursor: "pointer" }}>CODE</th>
                <th style={{ width: "11%" }}>INTERMEDIARIO</th>
                <th style={{ width: "7%", cursor: "pointer" }} onClick={() => handleSort("ejecutivo")}>
                  EJECUTIVO{" "}
                  {sortConfig.key === "ejecutivo" && (
                    <span style={{ fontSize: "10px", opacity: 0.6 }}>{sortConfig.direction === "asc" ? "▲" : "▼"}</span>
                  )}
                </th>
                <th colSpan="3" style={{ width: "6%" }}>
                  ACCIONES
                </th>
              </tr>
            </thead>
            <tbody className="table-striped" style={{ height: "35px", lineHeight: "35px" }}>
              {(modoComparar ? oportunidadesComparar : sortedOportunidades).length === 0 ? (
                <tr>
                  <td colSpan={modoComparar ? 16 : 15} className="text-center">
                    {modoComparar
                      ? "No hay clientes con 2+ propuestas al 50%, 75% o 90%"
                      : "No hay ventas ni oportunidades según los filtros seleccionados :("}
                  </td>
                </tr>
              ) : (
                (modoComparar ? oportunidadesComparar : sortedOportunidades).map((oportunidad) => (
                  <Fragment key={`${oportunidad.type || "regular"}-${oportunidad.id}`}>
                    <tr
                      onClick={oportunidad.type === "contrato" ? () => toggleContrato(oportunidad.id) : undefined}
                      style={{
                        height: "35px",
                        lineHeight: "35px",
                        cursor: oportunidad.type === "contrato" ? "pointer" : undefined,
                        backgroundColor:
                          modoComparar && selectedClientId && Number(oportunidad.client_id) !== selectedClientId
                            ? "#f8f9fa"
                            : undefined,
                        opacity:
                          modoComparar && selectedClientId && Number(oportunidad.client_id) !== selectedClientId
                            ? 0.45
                            : 1,
                      }}
                    >
                      {modoComparar && (
                        <td className="text-center align-middle">
                          <input
                            type="checkbox"
                            checked={isSelectedComparar(oportunidad)}
                            onChange={() => handleSelectComparar(oportunidad)}
                            disabled={
                              !isSelectedComparar(oportunidad) &&
                              seleccionComparar.length >= 4 &&
                              selectedClientId === Number(oportunidad.client_id)
                            }
                            style={{ cursor: "pointer", width: "16px", height: "16px" }}
                          />
                        </td>
                      )}
                      <td className="text-center align-middle">
                        {oportunidad.type === "contrato" && (
                          <span
                            style={{
                              marginRight: 4,
                              display: "inline-block",
                              transform: expandedContratos.has(oportunidad.id) ? "rotate(90deg)" : "rotate(0deg)",
                              transition: "transform 0.2s",
                            }}
                          >
                            ▶
                          </span>
                        )}
                        {oportunidad.type === "contrato" && oportunidad.display_id
                          ? oportunidad.display_id
                          : oportunidad.id}
                      </td>
                      <td className="text-start align-middle">{oportunidad.cliente}</td>
                      <td className="text-start align-middle">
                        {(oportunidad.campana
                          ? oportunidad.campana.length > 18
                            ? oportunidad.campana.slice(0, 18) + "..."
                            : oportunidad.campana
                          : "-"
                        ).toUpperCase()}
                      </td>
                      <td className="text-center align-middle">
                        {oportunidad.mes_cierre &&
                        typeof oportunidad.mes_cierre === "string" &&
                        /^\d{2}-\d{4}$/.test(oportunidad.mes_cierre)
                          ? `${mesEnLetras(oportunidad.mes_cierre.split("-")[0])}/${oportunidad.mes_cierre
                              .split("-")[1]
                              .slice(-2)}`
                          : "-"}
                      </td>
                      <td className="text-center align-middle">
                        {oportunidad.type === "contrato" ? (
                          <span>
                            {oportunidad.mes_inicio && mesEnLetras(oportunidad.mes_inicio.split("-")[0])}/
                            {oportunidad.mes_inicio?.split("-")[1]?.slice(-2)}
                            {" → "}
                            {oportunidad.mes_fin && mesEnLetras(oportunidad.mes_fin.split("-")[0])}/
                            {oportunidad.mes_fin?.split("-")[1]?.slice(-2)}
                          </span>
                        ) : oportunidad.facturafecha ? (
                          `${new Date(oportunidad.facturafecha)
                            .toLocaleString(localString(pais), { month: "short" })
                            .replace(/\.$/, "")
                            .toUpperCase()}/${new Date(oportunidad.facturafecha).getFullYear().toString().slice(-2)}`
                        ) : oportunidad.mes_factura &&
                          typeof oportunidad.mes_factura === "string" &&
                          /^\d{2}-\d{4}$/.test(oportunidad.mes_factura) ? (
                          `${mesEnLetras(oportunidad.mes_factura.split("-")[0])}/${oportunidad.mes_factura
                            .split("-")[1]
                            .slice(-2)}`
                        ) : (
                          "-"
                        )}
                      </td>
                      <td className="text-end align-middle">
                        {viewInUSD
                          ? formatMoneda(getImporteEnUSD(oportunidad, getDolarValue, fallbackRate), true)
                          : formatMoneda(
                              oportunidad.type === "btl" ? oportunidad.total_investment || 0 : oportunidad.importe || 0,
                              oportunidad.moneda_dolar
                            )}
                      </td>
                      <td
                        className={`text-center align-middle ${
                          oportunidad.estatus === "100%"
                            ? "bg-success text-white"
                            : oportunidad.estatus === "90%"
                              ? "bg-danger text-white"
                              : oportunidad.estatus === "75%"
                                ? "bg-primary text-white"
                                : oportunidad.estatus === "50%"
                                  ? "bg-warning text-dark"
                                  : "bg-black text-white"
                        }`}
                      >
                        {oportunidad.estatus}
                      </td>
                      <td className="text-center align-middle">
                        {oportunidad.code && oportunidad.code !== "-" ? (
                          <span
                            style={{ cursor: "pointer", color: "#007bff" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleShowDetails(oportunidad);
                            }}
                          >
                            {oportunidad.code}
                          </span>
                        ) : (
                          "-"
                        )}
                      </td>
                      {/* <td className="text-center align-middle">
                      {oportunidad.type === "btl" ? (
                        "BTL"
                      ) : oportunidad.type === "contrato" ? (
                        <span>
                          {oportunidad.tipo === "p" ? "P" : "D"}
                          <span
                            className="badge bg-info text-white ms-1"
                            style={{ fontSize: "0.6rem", verticalAlign: "middle" }}
                          >
                            {oportunidad.meses_actividad}M
                          </span>
                          {oportunidad.personas_comprometidas && (
                            <span
                              className="badge bg-warning text-dark ms-1"
                              style={{ fontSize: "0.6rem", verticalAlign: "middle" }}
                            >
                              AR
                            </span>
                          )}
                        </span>
                      ) : oportunidad.tipo === null || oportunidad.tipo === "d" ? (
                        "D"
                      ) : oportunidad.tipo === "p" ? (
                        "P"
                      ) : oportunidad.tipo === "m" ? (
                        "M"
                      ) : (
                        oportunidad.tipo || "-"
                      )}
                    </td> */}
                      {/* <td className="text-center align-middle">
                      {oportunidad.formatopauta === "A"
                        ? "5"
                        : oportunidad.formatopauta === "B"
                          ? "10"
                          : oportunidad.formatopauta === "C"
                            ? "20"
                            : oportunidad.formatopauta}
                    </td>
                    <td className="text-center align-middle">{oportunidad.periodopauta}</td> */}
                      <td className="text-center align-middle">
                        {oportunidad.type === "btl"
                          ? "EDIFICIOS"
                          : (() => {
                              const clientIntermediary = clienteIntermediarioMap[oportunidad.client_id];
                              return clientIntermediary && intermediaryMap[clientIntermediary]
                                ? intermediaryMap[clientIntermediary]
                                : "-";
                            })()}
                      </td>
                      <td className="text-center align-middle">{oportunidad.ejecutivo}</td>
                      <td className="text-center align-middle">
                        {oportunidad.type === "btl" || !puedeEditarOportunidad(oportunidad) ? (
                          "-"
                        ) : (
                          <TiFlash
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFlashEdit(oportunidad);
                            }}
                          />
                        )}
                      </td>
                      <td className="text-center align-middle">
                        {oportunidad.type === "btl" ||
                        oportunidad.type === "contrato" ||
                        !puedeEditarOportunidad(oportunidad) ? (
                          "-"
                        ) : (
                          <FaEdit
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(oportunidad);
                            }}
                          />
                        )}
                      </td>
                      <td className="text-center align-middle">
                        {!puedeEditarOportunidad(oportunidad) ? (
                          "-"
                        ) : (
                          <FaTrash
                            onClick={(e) => {
                              e.stopPropagation();
                              handleConfirmationModal({
                                id: oportunidad.type === "btl" ? oportunidad.full_id : oportunidad.id,
                                type: oportunidad.type,
                              });
                            }}
                          />
                        )}
                      </td>
                    </tr>
                    {oportunidad.type === "contrato" &&
                      expandedContratos.has(oportunidad.id) &&
                      oportunidad.meses &&
                      oportunidad.meses.map((mesObj, idx) => (
                        <tr
                          key={`contrato-${oportunidad.id}-mes-${idx}`}
                          style={{ backgroundColor: "rgba(0,0,0,0.02)" }}
                        >
                          {modoComparar && <td className="text-center align-middle">-</td>}
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">
                            <span style={{ fontWeight: 500 }}>
                              {mesEnLetras(mesObj.mes.split("-")[0])}/{mesObj.mes.split("-")[1]?.slice(-2)}
                            </span>
                          </td>
                          <td className="text-end align-middle">
                            {formatMoneda(mesObj.importe, oportunidad.moneda_dolar)}
                          </td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">-</td>
                          <td className="text-center align-middle">
                            {!mesObj.facturanumero &&
                            puedeEditarOportunidad({ ...oportunidad, facturanumero: null }) ? (
                              <TiFlash
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleFlashEdit({ ...oportunidad, facturanumero: null });
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td className="text-center align-middle">
                            {canAssignEdificios && !mesObj.facturanumero
                              ? (() => {
                                  const tieneEdif = tieneEdificiosAsignados(mesObj.edificios_ids);
                                  return (
                                    <FaBuilding
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setEdificiosModalData({ contratoId: oportunidad.id, idx });
                                      }}
                                      title={tieneEdif ? "Modificar edificios asignados" : "Asignar edificios"}
                                      style={{ cursor: "pointer", color: tieneEdif ? "#198754" : "#dc3545" }}
                                    />
                                  );
                                })()
                              : "-"}
                          </td>
                          <td className="text-center align-middle">-</td>
                        </tr>
                      ))}
                  </Fragment>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal isOpen={isEditing} toggle={() => setIsEditing(false)} size="xl">
        <ModalHeader>Editar Oportunidad #{editingOpportunity?.id || "Cargando..."}</ModalHeader>
        <ModalBody>
          {editingOpportunity ? (
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmitEdit)}>
                <div className="row g-3">
                  <div className="col-4">
                    <label htmlFor="estatus" className="form-label">
                      Estatus
                    </label>
                    <select
                      className={`form-control ${errors.estatus ? "is-invalid" : ""}`}
                      id="estatus"
                      {...register("estatus", { required: true })}
                    >
                      <option value="">Selecciona un porcentaje</option>
                      <option value="100%">100%</option>
                      <option value="90%">90%</option>
                      <option value="75%">75%</option>
                      <option value="50%">50%</option>
                      <option value="0%">0%</option>
                    </select>
                    {errors.estatus && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  <div className="col-4">
                    <label htmlFor="mes_cierre" className="form-label">
                      Mes de Cierre
                    </label>
                    <select
                      className={`form-control ${errors.mes_cierre ? "is-invalid" : ""}`}
                      id="flash_mes_cierre"
                      {...register("mes_cierre", { required: true })}
                    >
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                    {errors.mes_cierre && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                  <div className="col-4">
                    <label htmlFor="mes" className="form-label">
                      Mes Facturación
                    </label>
                    <select
                      className={`form-control ${errors.mes ? "is-invalid" : ""}`}
                      id="mes"
                      {...register("mes", { required: true })}
                      defaultValue={editingOpportunity?.mes || "01"}
                    >
                      {months.map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.label}
                        </option>
                      ))}
                    </select>
                    {errors.mes && <div className="invalid-feedback">Este campo es obligatorio</div>}
                  </div>
                </div>
              </form>
            </FormProvider>
          ) : (
            <p>Cargando...</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setIsEditing(false)} disabled={loading}>
            Cancelar
          </Button>
          <Button color="primary" onClick={handleSubmit(onSubmitEdit)} disabled={loading}>
            {loading ? "Guardando..." : "Guardar"}
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showConfirmationModal} toggle={() => setShowConfirmationModal(false)}>
        <ModalHeader>Confirmación</ModalHeader>
        <ModalBody>¿Está seguro de eliminar esta oportunidad?</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowConfirmationModal(false)}>
            Cancelar
          </Button>
          <Button color="primary" onClick={() => handleDelete(deletedOpportunity.id, deletedOpportunity.type)}>
            Eliminar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={showDetailsModal} toggle={() => setShowDetailsModal(false)} size="xl">
        <ModalHeader toggle={() => setShowDetailsModal(false)} style={{ padding: "10px 15px" }}>
          <div className="d-flex align-items-center w-100">
            <div>
              <span>Detalles de la cotización #{selectedOpportunity?.code}</span>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {selectedOpportunity ? (
            <div className="details-container">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <strong>Ejecutivo:</strong>{" "}
                    {users.find((user) => user.id.toString() === selectedOpportunity.ejecutivo.toString())?.nombre ||
                      selectedOpportunity.ejecutivo}
                  </p>
                  <p>
                    <strong>Cliente:</strong> {selectedOpportunity.cliente}
                  </p>
                  <p>
                    <strong>Importe:</strong>{" "}
                    {viewInUSD
                      ? formatMoneda(getImporteEnUSD(selectedOpportunity, getDolarValue, fallbackRate), true)
                      : formatMoneda(
                          selectedOpportunity.type === "btl"
                            ? selectedOpportunity.total_investment || 0
                            : selectedOpportunity.importe || 0,
                          selectedOpportunity.moneda_dolar
                        )}
                  </p>
                  <p>
                    <strong>Mes de Cierre:</strong>{" "}
                    {selectedOpportunity.mes_cierre ? mesEnLetras(selectedOpportunity.mes_cierre.split("-")[0]) : "-"}
                  </p>
                  <p>
                    <strong>Mes Facturación:</strong>{" "}
                    {selectedOpportunity.mes_factura ? mesEnLetras(selectedOpportunity.mes_factura.split("-")[0]) : "-"}
                  </p>
                  <p>
                    <strong>Intermediario:</strong>{" "}
                    {intermediaryMap[selectedOpportunity.intermediario] || selectedOpportunity.intermediario || "-"}
                  </p>
                  <p>
                    <strong>Frecuencia:</strong>{" "}
                    {selectedOpportunity.formatopauta === "A"
                      ? "5"
                      : selectedOpportunity.formatopauta === "B"
                        ? "10"
                        : selectedOpportunity.formatopauta === "C"
                          ? "20"
                          : selectedOpportunity.formatopauta}
                  </p>
                  <p>
                    <strong>Días:</strong> {selectedOpportunity.periodopauta}
                  </p>
                  <p>
                    <strong>Tipo:</strong>{" "}
                    {selectedOpportunity.tipo === null || selectedOpportunity.tipo === "d"
                      ? "D"
                      : selectedOpportunity.tipo === "p"
                        ? "P"
                        : selectedOpportunity.tipo === "m"
                          ? "M"
                          : selectedOpportunity.tipo || "-"}
                  </p>
                  <p>
                    <strong>Pantallas Totales:</strong> {selectedOpportunity.pantallastotales}
                  </p>
                  <p>
                    <strong>Edificios Totales:</strong> {selectedOpportunity.edificiostotales}
                  </p>
                  <div>
                    <strong
                      onClick={toggleBuildingsList}
                      style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    >
                      Edificios participantes{" "}
                      <span style={{ marginLeft: "5px" }}>{isBuildingsExpanded ? "▼" : "▶"}</span>
                    </strong>
                    <Collapse isOpen={isBuildingsExpanded}>
                      <ul>
                        {selectedOpportunity?.edificiosparticipantes?.length > 0 && edificios.length > 0 ? (
                          [...new Set(selectedOpportunity.edificiosparticipantes.split(","))].map((id, index) => {
                            const edificio = edificios.find((ed) => ed.id.toString() === id.trim());
                            return edificio ? (
                              <li key={`${id}-${index}`}>{edificio.edificio}</li>
                            ) : (
                              <li key={`${id}-${index}`}>Edificio ID {id} (desconocido)</li>
                            );
                          })
                        ) : edificios.length === 0 ? (
                          <li>No se pudieron cargar los edificios</li>
                        ) : (
                          <li>-</li>
                        )}
                      </ul>
                    </Collapse>
                  </div>
                </div>
              </div>
              {selectedOpportunity.facturanumero && (
                <div className="mt-3">
                  <h6>Información de Facturación</h6>
                  <p>
                    <strong>Número de Factura:</strong> {selectedOpportunity.facturanumero}
                  </p>
                  <p>
                    <strong>Fecha de Factura:</strong>{" "}
                    {new Date(selectedOpportunity.facturafecha).toLocaleDateString(localString(pais))}
                  </p>
                  <p>
                    <strong>Fecha de Cobro:</strong>{" "}
                    {selectedOpportunity.facturafechacobro
                      ? new Date(selectedOpportunity.facturafechacobro).toLocaleDateString(localString(pais))
                      : "-"}
                  </p>
                </div>
              )}
            </div>
          ) : (
            <p>Cargando...</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowDetailsModal(false)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
      <FlashEditModal
        isOpen={isFlashEditing}
        onClose={() => {
          setIsFlashEditing(false);
          setFlashEditingOpportunity(null);
        }}
        opportunity={flashEditingOpportunity}
        onSave={onSubmitFlashEdit}
        saving={flashSaving}
        hideFacturacion={flashEditingOpportunity?.type === "contrato"}
        intermediarios={intermediarios}
        clientes={clientes}
      />
      <ModalAsignarEdificios
        show={edificiosModalData != null}
        onHide={() => setEdificiosModalData(null)}
        onSave={handleSaveEdificiosCuota}
        pais={pais}
        personasComprometidas={edificiosCuotaCtx?.personasComprometidas || 0}
        edificiosIdsActuales={edificiosCuotaCtx?.edificiosIds || null}
        mesLabel={edificiosCuotaCtx?.mesLabel || ""}
      />
      {/* Botón flotante comparar */}
      {modoComparar && seleccionComparar.length >= 2 && (
        <button
          className="btn btn-dark"
          onClick={async () => {
            const codigos = seleccionComparar.map((op) => op.code).filter(Boolean);
            if (codigos.length > 0) {
              try {
                const cots = await getCotizacionesByCodigos(codigos);
                setCotizacionesComparar(cots);
              } catch {
                setCotizacionesComparar([]);
              }
            } else {
              setCotizacionesComparar([]);
            }
            setComparadorOpen(true);
          }}
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            zIndex: 1050,
            borderRadius: "24px",
            padding: "10px 24px",
            fontWeight: 600,
            boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          }}
        >
          Comparar ({seleccionComparar.length})
        </button>
      )}
      <ComparadorModal
        isOpen={comparadorOpen}
        toggle={() => setComparadorOpen(false)}
        oportunidades={seleccionComparar}
        cotizaciones={cotizacionesComparar}
        pais={pais}
        viewInUSD={viewInUSD}
        getDolarValue={getDolarValue}
        fallbackRate={fallbackRate}
      />
    </div>
  );
};
